import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "../../../styles/breakpoints";
import { vars } from "../../../styles/theme.css";

const elementNameBaseStyles = style({
  borderRadius: "3px 3px 0 0",
  backgroundColor: vars.colors.white,
  padding: 2.5,
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: 1,
  whiteSpace: "nowrap",
  color: vars.colors.primaryFixed,
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      padding: vars.space["2xs"],
    },
  },
});

export const elementNameVariants = styleVariants({
  0: [elementNameBaseStyles, vars.colors.copnr[0]],
  25: [elementNameBaseStyles, vars.colors.copnr[25]],
  50: [elementNameBaseStyles, vars.colors.copnr[50]],
  75: [elementNameBaseStyles, vars.colors.copnr[75]],
  default: [elementNameBaseStyles],
});
